import { useEffect, useContext, useRef, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import ProspectList, { ListOptions } from "./ProspectList";
import { DEFAULT_LIST_SORT } from "../../listSort";
import ProspectEdit from "./ProspectEdit";
import { hasAnyRole } from "../../utils/roles";
import { MDSplitView } from "@solsys/solsys-reactjs";

export default function ProspectController({
  navigate,
  action,
  id,
  search,
  style,
  options = {},
}) {
  let listState = {
    [ListOptions.sortBy]: DEFAULT_LIST_SORT.sortBy,
    [ListOptions.sortDirection]: DEFAULT_LIST_SORT.sortDirection,
    [ListOptions.tab]: "Chat",
    [ListOptions.name]: null,
    [ListOptions.statusId]: null,
  };
  const { user } = useAuth();
  const didMount = useRef(false);
  const allowedRoles = ["administrator"];
  useEffect(() => (didMount.current ? undefined : (didMount.current = true)));
  if (!didMount.current && Object.keys(search).length) {
    Object.keys(ListOptions).forEach((key) => {
      listState[key] = search[key];
    });
  }

  listState = useState(listState);

  return (
    <div className="prospects">
      <MDSplitView
        globalName="ProspectMDV"
        style={ style }
        action={ action }
        master={ ({ isNarrow, autoSelect }) => (
          <ProspectList
            isMaster={ hasAnyRole(user, allowedRoles) }
            state={ listState }
            id={ id }
            action={ action }
            onStateChange={ (state) => {
              navigate({
                action,
                id,
                search: state,
                push: false,
              });
            } }
            onSelect={ (newId, userInteraction) => {
              if (
                newId &&
                id &&
                String(newId) === String(id) &&
                userInteraction
              ) {
                navigate({
                  popOut: isNarrow,
                  action: "list",
                  id: null,
                  search: listState[0],
                });
              } else {
                navigate({
                  popOut: isNarrow,
                  ...(newId === 0
                    ? {
                      action: "add",
                      id: null,
                    }
                    : {
                      action: "edit",
                      id: newId,
                    }),
                  search: listState[0],
                });
              }
            } }
          />
        ) }
        detail={ () => {
          const hasEditPermission = hasAnyRole(user, allowedRoles);
          return (
            <ProspectEdit
              key={ `action_${action}_id_${id}` }
              id={ id }
              action={ action }
              navigate={ navigate }
              tab={ search['tab'] }
              readOnly={ !hasEditPermission }
            />
          );
        } }
        initialWidth={ 300 }
        maxWidth={ 800 }
        minWidth={ 290 }
      />
    </div>
  );
}
